// Ajouter aux favoris
export const FAVORITE_ADD_REQUEST = 'FAVORITE_ADD_REQUEST';
export const FAVORITE_ADD_SUCCESS = 'FAVORITE_ADD_SUCCESS';
export const FAVORITE_ADD_FAIL = 'FAVORITE_ADD_FAIL';

// Supprimer des favoris
export const FAVORITE_REMOVE_REQUEST = 'FAVORITE_REMOVE_REQUEST';
export const FAVORITE_REMOVE_SUCCESS = 'FAVORITE_REMOVE_SUCCESS';
export const FAVORITE_REMOVE_FAIL = 'FAVORITE_REMOVE_FAIL';
export const FAVORITE_REMOVE_LOCAL= 'FAVORITE_REMOVE_LOCAL';
// 🚀 PERF : bascule optimiste (l'UI réagit immédiatement, sans attendre le réseau)
export const FAVORITE_OPTIMISTIC_TOGGLE = 'FAVORITE_OPTIMISTIC_TOGGLE';
// Récupérer les favoris
export const FAVORITE_FETCH_REQUEST = 'FAVORITE_FETCH_REQUEST';
export const FAVORITE_FETCH_SUCCESS = 'FAVORITE_FETCH_SUCCESS';
export const FAVORITE_FETCH_FAIL = 'FAVORITE_FETCH_FAIL';
